import React from 'react';
import TarjetaMenu from '../Navegacion/TarjetaMenu';

const ITEMS = [
    {
        nombre: 'Insumos',
        descripcion: 'Ingredientes y materias primas que usan tus recetas.',
        icono: 'fas fa-carrot',
        url: '/admin/inventario/insumos',
        permitido: true,
    },
    {
        nombre: 'Recepción de Compras',
        descripcion: 'Registra el ingreso de insumos comprados a un proveedor.',
        icono: 'fas fa-truck-loading',
        url: '/admin/inventario/recepcion',
        permitido: true,
    },
    {
        nombre: 'Proveedores',
        descripcion: 'Administra los proveedores de tus insumos.',
        icono: 'fas fa-handshake',
        url: '/admin/inventario/proveedores',
        permitido: true,
    },
    {
        nombre: 'Stock y Kardex',
        descripcion: 'Stock y ajustes de productos, más el historial combinado de productos e insumos.',
        icono: 'fas fa-boxes',
        url: '/admin/inventario/stock',
        permitido: true,
    },
];

function HomeInventario() {
    return (
        <div className="contenedorHome">
            <div className="card">
                <div className="card-header">
                    <div className="titulo-formulario d-flex justify-content-center">
                        <div className="col-md-12"><i className="fas fa-warehouse"></i> Inventario</div>
                    </div>
                </div>
                <div className="card-body" style={{ paddingLeft: "5%", paddingRight: "5%" }}>
                    <div className="row">
                        {ITEMS.map(item => (
                            <TarjetaMenu key={item.url} item={item} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeInventario;
